import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { SurveyDataProvider } from "../../data-provider/survey.dp";

let SurveyForm = {
    selector: "vcSurveyForm",
    templateUrl:
        "/angular/components/survey/survey-details-form.component.html",
    bindings: {
        selectedSurvey: "=",
        teamOnly: "=",
    },
    controller: class SurveyFormController {
        // * bindings for typescript compiler *
        public selectedSurvey: any;
        public teamOnly: any;
        // ************************************

        public isOrganisationType: boolean;
        public survey: any;
        public saving = false;

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private dataProvider: SurveyDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            SurveyDataProvider: SurveyDataProvider,
            ToastUtils: ToastUtils,
            __app_type: string
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = SurveyDataProvider;
            this.isOrganisationType = __app_type == "LEADER";
        }

        $onInit() {
            this.survey = _.cloneDeep(this.selectedSurvey);
            if (!this.survey || !this.survey.sid) {
                this.survey = { sname: "", sdescription: "", signature: "0" };
            }
        }

        createSurvey(): void {
            this.saving = true;
            this.dataProvider.create(this.survey).then(
                (survey: any) => {
                    this.saving = false;
                    this.dialog.hide(survey);
                },
                () => {
                    this.saving = false;
                    this.toast.error();
                }
            );
        }

        updateSurvey(): void {
            this.saving = true;
            this.dataProvider.update(this.survey).then(
                (survey: any) => {
                    this.saving = false;
                    this.dialog.hide(survey);
                },
                () => {
                    this.saving = false;
                    this.toast.error();
                }
            );
        }

        save(): void {
            if (this.survey.sid) {
                this.updateSurvey();
            } else {
                this.createSurvey();
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular.module("survey").component(SurveyForm.selector, SurveyForm);
